/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ServiceModelDetail } from "./ServiceModelDetail";
import {
    ServiceModelDetailFromJSON,
    ServiceModelDetailFromJSONTyped,
    ServiceModelDetailToJSON,
} from "./ServiceModelDetail";

/**
 * Extra details for DeviceGroupType=ServiceModel
 * @export
 * @interface DeviceGroupServiceModelConfigDto
 */
export interface DeviceGroupServiceModelConfigDto {
    /**
     * Optional name/ID of the service model in JIRA. If empty, falls back to device group name
     * @type {string}
     * @memberof DeviceGroupServiceModelConfigDto
     */
    externalServiceModelName?: string;
    /**
     * Optional description of the service model config for this device group.
     * @type {string}
     * @memberof DeviceGroupServiceModelConfigDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupServiceModelConfigDto
     */
    availability?: DeviceGroupServiceModelConfigDtoAvailabilityEnum;
    /**
     *
     * @type {boolean}
     * @memberof DeviceGroupServiceModelConfigDto
     */
    monitored?: boolean;
    /**
     * SL1-4 Details
     * @type {Array<ServiceModelDetail>}
     * @memberof DeviceGroupServiceModelConfigDto
     */
    serviceModelDetails?: Array<ServiceModelDetail>;
}

/**
 * @export
 */
export const DeviceGroupServiceModelConfigDtoAvailabilityEnum = {
    Unknown: "Unknown",
    BusinessHours: "BusinessHours",
    Available24x7: "Available24x7",
    Varies: "Varies",
} as const;
export type DeviceGroupServiceModelConfigDtoAvailabilityEnum =
    (typeof DeviceGroupServiceModelConfigDtoAvailabilityEnum)[keyof typeof DeviceGroupServiceModelConfigDtoAvailabilityEnum];

/**
 * Check if a given object implements the DeviceGroupServiceModelConfigDto interface.
 */
export function instanceOfDeviceGroupServiceModelConfigDto(
    value: object,
): value is DeviceGroupServiceModelConfigDto {
    return true;
}

export function DeviceGroupServiceModelConfigDtoFromJSON(
    json: any,
): DeviceGroupServiceModelConfigDto {
    return DeviceGroupServiceModelConfigDtoFromJSONTyped(json, false);
}

export function DeviceGroupServiceModelConfigDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupServiceModelConfigDto {
    if (json == null) {
        return json;
    }
    return {
        externalServiceModelName:
            json["externalServiceModelName"] == null
                ? undefined
                : json["externalServiceModelName"],
        description:
            json["description"] == null ? undefined : json["description"],
        availability:
            json["availability"] == null ? undefined : json["availability"],
        monitored: json["monitored"] == null ? undefined : json["monitored"],
        serviceModelDetails:
            json["serviceModelDetails"] == null
                ? undefined
                : (json["serviceModelDetails"] as Array<any>).map(
                      ServiceModelDetailFromJSON,
                  ),
    };
}

export function DeviceGroupServiceModelConfigDtoToJSON(
    value?: DeviceGroupServiceModelConfigDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        externalServiceModelName: value["externalServiceModelName"],
        description: value["description"],
        availability: value["availability"],
        monitored: value["monitored"],
        serviceModelDetails:
            value["serviceModelDetails"] == null
                ? undefined
                : (value["serviceModelDetails"] as Array<any>).map(
                      ServiceModelDetailToJSON,
                  ),
    };
}
